export default __webpack_public_path__ + "static/bg-1-b146f41bddea901618ecd76b1f4c32aa.png";